import firebase from 'firebase/app'
import { HTTP } from '@/http-common'

export default {
  state: {
    loadedReadings: [],
    readingsLoading: false
  },
  getters: {
    loadedReadings (state) {
      return state.loadedReadings
    },
    readingsLoading (state) {
      return state.readingsLoading
    }
  },
  // synchronous
  mutations: {
    setLoadedReadings (state, payload) {
      state.loadedReadings = payload
    },
    setReadingsLoading (state, payload) {
      state.readingsLoading = payload
    },
    clearLoadedReadings (state) {
      state.loadedReadings = []
    }
  },
  // asynchronous
  actions: {
    loadReadings ({ commit }, payload) {
      console.log('load readings here')
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedReadings', [])

      firebase.auth().currentUser.getIdToken()
        .then(token => {
          HTTP.get('smaai5/reading?mac=' + payload.mac + '&offset=' + payload.offset + '&limit=25&order=DESC',
            { headers: { 'Authorization': 'Bearer ' + token } })
            .then(res => {
              console.log(res)
              if (Array.isArray(res.data)) {
                let id = 0
                const _data = res.data.map(function (data) {
                  data.id = id
                  id = id + 1
                  return data
                })
                commit('setLoadedReadings', _data)
              }
              commit('setLoading', false)
            })
            .catch(err => {
              console.log(err)
              commit('setLoading', false)
              commit('setError', err)
            })
        })
        .catch(err => {
          console.log(err)
          commit('setLoading', false)
          commit('setError', err)
        })
    },
    loadReadingsWithReadingsLoading ({ commit }, payload) {
      console.log('load readings here')
      commit('clearError')
      commit('setReadingsLoading', true)
      commit('setLoadedReadings', [])

      firebase.auth().currentUser.getIdToken()
        .then(token => {
          HTTP.get('smaai5/reading?mac=' + payload.mac + '&offset=' + payload.offset + '&limit=25&order=DESC',
            { headers: { 'Authorization': 'Bearer ' + token } })
            .then(res => {
              console.log(res)
              if (Array.isArray(res.data)) {
                let id = 0
                const _data = res.data.map(function (data) {
                  data.id = id
                  id = id + 1
                  return data
                })
                commit('setLoadedReadings', _data)
              }
              commit('setReadingsLoading', false)
            })
            .catch(err => {
              console.log(err)
              commit('setReadingsLoading', false)
              commit('setError', err)
            })
        })
        .catch(err => {
          console.log(err)
          commit('setReadingsLoading', false)
          commit('setError', err)
        })
    },
    clearLoadedReadings ({ commit }) {
      commit('clearLoadedReadings')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reading/index.js